// extracted by mini-css-extract-plugin
export var actionButton = "_8y-1";
export var actionButtons = "_8y-2";
export var actions = "_8y-0";
export var aiUnread = "_8y-10";
export var alignCenter = "_8y-h";
export var backWrapper = "_8y-3";
export var cellContainer = "_8y-4";
export var checkboxContainer = "_8y-5";
export var contentContainer = "_8y-6";
export var contentHeader = "_8y-8";
export var conversationsTableWrapper = "_8y-s";
export var draftReplyBadgeContainer = "_8y-m";
export var dropdownItem = "_8y-b";
export var dropdownItemsContainer = "_8y-a";
export var dropdownTitle = "_8y-c";
export var errorIcon = "_8y-7";
export var filter = "_8y-d";
export var gray = "_8y-i";
export var headerActionButtons = "_8y-e";
export var headerCheckboxContainer = "_8y-f";
export var icon = "_8y-j";
export var menuContainer = "_8y-k";
export var noMoreTicketsIcon = "_8y-12";
export var noMoreTicketsSubText = "_8y-13";
export var oneLine = "_8y-l";
export var optionsButton = "_8y-n";
export var plus = "_8y-o";
export var portalButtonsWrapper = "_8y-g";
export var red = "_8y-p";
export var scrolledTop = "_8y-9";
export var search = "_8y-q";
export var selectedConversationsCount = "_8y-r";
export var spinner = "_8y-t";
export var strong = "_8y-u";
export var summaryCell = "_8y-v";
export var tableContainer = "_8y-11";
export var tagContainer = "_8y-w";
export var threeDots = "_8y-x";
export var twoLines = "_8y-y";
export var unread = "_8y-z";